// extracted by mini-css-extract-plugin
module.exports = {"box":"SmallLogo_box__xYSrL","top":"SmallLogo_top__1TPEc","bottom":"SmallLogo_bottom__1pX7P","logo":"SmallLogo_logo__3Fx2o","charity":"SmallLogo_charity__3bKwM"};